import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {fetchProductByID} from "../../../../reduxLib/productLib";
import addToCart from "../../../../cookieStorage/addToCard";
import ProductRelated from "./productRelated";


function ProductPage() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {productId} = useParams();
    const [poductDetails, setProductDetails] = useState(null);
    const [selectedColorId, setSelectedColorId] = useState(null);
    const products = useSelector((state) => state.productreducer.selectedProduct);
    const state=useSelector((state) => state.productreducer.state);

    const [quantity, setQuantity] = useState(1);

    //Buttons
    const [selectedTextile, setSelectedTextile] = useState("");
    const [selectedClosing, setSelectedClosing] = useState("");
    const [selectedPlexis, setSelectedPlexis] = useState("");
    const [images,setImages]=useState([]);

    const filteredAllowedColors = (poductDetails?.allowedColors ?? []).filter(
        (color) => color.textiles === selectedTextile
    );

    const [activeTab, setActiveTab] = useState("description");

    const [mainImage, setMainImage] = useState(
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/5f4b7114f8-4f925d337e9663c51183.png"
    );

    useEffect(() => {
        if (!poductDetails) return;

        const textiles = poductDetails.availableTextiles ?? [];
        const plexis = poductDetails.availablePlexis ?? [];
        const closings = poductDetails.availableClosingTextiles ?? [];
        const colors = poductDetails.allowedColors ?? [];

        setSelectedTextile(textiles[0] ?? "");
        setSelectedPlexis(plexis[0] ?? "");
        setSelectedClosing(closings[0] ?? "");
        setSelectedColorId(colors[0]?.pcid ?? null);
    }, [poductDetails]);

    useEffect(() => {

        dispatch(fetchProductByID(productId))
            .then((action) => {

                if (action.payload) {

                    setProductDetails(action.payload);

                    const imgs = (action.payload.filesRelated || [])
                        .map(f => f?.fileLocation)
                        .filter(Boolean);

                    setImages(imgs);
                    setMainImage(imgs[0] || "");
                }
            });

    }, [dispatch, productId]);
    useEffect(() => {
        if (poductDetails?.colors?.length && selectedColorId == null) {
            setSelectedColorId(poductDetails.colors[0].pcid);

        }
    }, [poductDetails, selectedColorId]);

    useEffect(() => {
        const filteredColors = (poductDetails?.allowedColors ?? []).filter(
            (color) => color.textiles === selectedTextile
        );

        if (
            filteredColors.length > 0 &&
            !filteredColors.some(c => c.pcid === selectedColorId)
        ) {
            setSelectedColorId(filteredColors[0].pcid);
        }
    }, [selectedTextile, poductDetails]);


    function QuantitySelector({ limit = 12 }) {


        const increment = () => {
            setQuantity(q => Math.min(limit, q + 1));
        };

        const decrement = () => {
            setQuantity(q => Math.max(1, q - 1));
        };

        return (
            <div className="mb-6 pb-6 border-b">
                <h3 className="text-lg font-semibold text-brand-green mb-3">
                    Quantity
                </h3>

                <div className="flex items-center space-x-4">
                    <div className="flex items-center border-2 border-gray-300 rounded-lg">
                        {/* − */}
                        <button
                            type="button"
                            onClick={decrement}
                            disabled={quantity === 1}
                            className="px-4 py-2 text-gray-600
                       disabled:opacity-40 disabled:cursor-not-allowed
                       hover:text-brand-green"
                        >
                            <i className="fa-solid fa-minus"></i>
                        </button>

                        {/* value */}
                        <input
                            type="text"
                            value={quantity}
                            readOnly
                            className="w-16 text-center border-l border-r border-gray-300 py-2 focus:outline-none"
                        />

                        {/* + */}
                        <button
                            type="button"
                            onClick={increment}
                            disabled={quantity === limit}
                            className="px-4 py-2 text-gray-600
                       disabled:opacity-40 disabled:cursor-not-allowed
                       hover:text-brand-green"
                        >
                            <i className="fa-solid fa-plus"></i>
                        </button>
                    </div>

                </div>
            </div>
        );
    }



    return (
        <div>
            <div id="continue-shopping" className="font-print mt-6" onClick={() => {
                navigate(`/products`)
            }}>
                <a href="#"
                   className="inline-flex items-center text-custom-green hover:text-dark-green font-medium transition-colors group">
                    <i className="fas fa-arrow-left mr-2 group-hover:-translate-x-1 transition-transform"></i>
                    Continue Shopping
                </a>
            </div>
            <section id="product-detail" className=" bg-cream py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                        <div id="product-gallery">
                            <div
                                className="main-image-container bg-cream rounded-lg overflow-hidden mb-4 shadow-md">
                                <img id="mainImage" className="w-full h-full object-cover"
                                     src={mainImage || poductDetails?.filesRelated?.[0]?.fileLocation}
                                     alt={poductDetails?.name}/>
                            </div>
                            <div className="grid grid-cols-4 gap-4">
                                {images?.map((img) => (
                                    <button
                                        key={img}
                                        type="button"
                                        onClick={() => {setMainImage(img);}}
                                        className={
                                            img === mainImage
                                                ? "h-32 bg-cream rounded-lg overflow-hidden cursor-pointer shadow-sm ring-2 ring-custom-green"
                                                : "h-32 bg-cream rounded-lg overflow-hidden cursor-pointer shadow-sm hover:shadow-md transition-shadow"
                                        }
                                    >
                                        <img className="w-full h-full object-cover" src={img} alt="thumb"/>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div id="product-info">
                            <div className="mb-6">
                                    <span
                                        className="inline-block bg-custom-green text-white text-xs px-3 py-1 rounded-full mb-4">In Stock</span>
                                <h1 className="text-4xl font-serif font-bold text-brand-green mb-3">{poductDetails?.name}</h1>
                                <div className="flex items-center mb-4">

                                </div>
                                <div className="flex items-baseline mb-6">
                                    <span className="text-4xl font-bold text-brand-green">€{poductDetails?.price}</span>
                                    {/*<span className="text-xl text-gray-400 line-through ml-3">€60.00</span>
                                    <span className="ml-3 bg-red-100 text-red-600 text-sm px-2 py-1 rounded">25% OFF</span>*/}
                                </div>
                            </div>

                            <div className="mb-6 pb-6 border-b">
                                <p className="text-gray-700 leading-relaxed mb-4">{poductDetails?.description}</p>
                                <ul className="space-y-2 text-gray-700">
                                    {(poductDetails?.availableTextiles?.length ?? 0) > 0 && (
                                        <li className="flex items-start">
                                            <i className="fa-solid fa-check text-brand-green mr-3 mt-1"></i>
                                            <span>Νήματα: {poductDetails.availableTextiles.join(", ")}</span>
                                        </li>
                                    )}

                                    {(poductDetails?.availablePlexis?.length ?? 0) > 0 && (
                                        <li className="flex items-start">
                                            <i className="fa-solid fa-check text-brand-green mr-3 mt-1"></i>
                                            <span>Πλέξεις: {poductDetails.availablePlexis.join(", ")}</span>
                                        </li>
                                    )}

                                    {(poductDetails?.availableClosingTextiles?.length ?? 0) > 0 && (
                                        <li className="flex items-start">
                                            <i className="fa-solid fa-check text-brand-green mr-3 mt-1"></i>
                                            <span>Κλεισίματα: {poductDetails.availableClosingTextiles.join(", ")}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            <div className="mb-6 pb-6 border-b">
                                <h3 className="text-lg font-semibold text-brand-green mb-3">Size</h3>
                                <p className="text-sm text-gray-600 mt-2">Μέγεθος: {poductDetails?.productSize}</p>
                            </div>

                            <div className="space-y-5">
                                <div>
                                    <h3 className="font-semibold text-gray-800 mb-3">Basket Color:</h3>
                                    <div className="grid grid-cols-4 md:grid-cols-6 gap-3 p-2 border rounded-lg">
                                        {filteredAllowedColors.map((color) => {
                                            const id = Number(color.pcid);
                                            const checked = selectedColorId === id;

                                            return (
                                                <label
                                                    key={id}
                                                    className="flex flex-col items-center cursor-pointer"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={() => setSelectedColorId(id)}
                                                        className="mb-1"
                                                    />

                                                    <div
                                                        className={`
              w-8 h-8 rounded-full border-2 transition-all
              ${
                                                            checked
                                                                ? "border-gray-900 scale-110 ring-2 ring-gray-400"
                                                                : "border-gray-200 hover:scale-105"
                                                        }
            `}
                                                        style={{ backgroundColor: color.hexColor }}
                                                        title={color.colorName}
                                                    />

                                                    <span className="text-[11px] mt-1 text-center leading-tight">
            {color.colorName}
          </span>
                                                </label>
                                            );
                                        })}
                                        {filteredAllowedColors.length === 0 && (
                                            <div className="col-span-full text-sm text-gray-500 p-2">
                                                No colors available.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {(poductDetails?.availableTextiles?.length ?? 0) > 0 && (
                                    <div>
                                        <h3 className="font-semibold text-gray-800 mb-3">Textile:</h3>

                                        <div className="flex flex-wrap gap-3">
                                            {poductDetails.availableTextiles.map((textile) => (
                                                <button
                                                    key={textile}
                                                    type="button"
                                                    onClick={() => setSelectedTextile(textile)}
                                                    className={
                                                        selectedTextile === textile
                                                            ? "px-4 py-2 border-2 border-custom-green bg-custom-green text-white rounded-lg"
                                                            : "px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-custom-green"
                                                    }
                                                >
                                                    {textile}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {(poductDetails?.availablePlexis?.length ?? 0) > 0 && (
                                    <div>
                                        <h3 className="font-semibold text-gray-800 mb-3">Πλέξη:</h3>

                                        <div className="flex flex-wrap gap-3">
                                            {poductDetails.availablePlexis.map((plexis) => (
                                                <button
                                                    key={plexis}
                                                    type="button"
                                                    onClick={() => setSelectedPlexis(plexis)}
                                                    className={
                                                        selectedPlexis === plexis
                                                            ? "px-4 py-2 border-2 border-custom-green bg-custom-green text-white rounded-lg"
                                                            : "px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-custom-green"
                                                    }
                                                >
                                                    {plexis}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {(poductDetails?.availableClosingTextiles?.length ?? 0) > 0 && (
                                    <div>
                                        <h3 className="font-semibold text-gray-800 mb-3">Textile Closing:</h3>

                                        <div className="flex flex-wrap gap-3">
                                            {poductDetails.availableClosingTextiles.map((closing) => (
                                                <button
                                                    key={closing}
                                                    type="button"
                                                    onClick={() => setSelectedClosing(closing)}
                                                    className={
                                                        selectedClosing === closing
                                                            ? "px-4 py-2 border-2 border-custom-green bg-custom-green text-white rounded-lg"
                                                            : "px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-custom-green"
                                                    }
                                                >
                                                    {closing}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}







                            </div>

                            <QuantitySelector limit={12}/>

                            <div className="flex space-x-4 mb-6">
                                <button onClick={() => {
                                    const product = {
                                        id: poductDetails.productID,
                                        name: poductDetails.name,
                                        image: poductDetails?.filesRelated?.[0]?.fileLocation,
                                        description: poductDetails.description,
                                        color: selectedColorId,//poductDetails?.colors?.[0],
                                        textile: selectedTextile,
                                        plexis: selectedPlexis,
                                        closing: selectedClosing,
                                        price: poductDetails.price,
                                        quantity: quantity
                                    };

                                    addToCart(product, quantity);
                                }}
                                        className="flex-1 bg-custom-green text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-opacity-90 transition-colors">
                                    <i className="fa-solid fa-shopping-cart mr-2"></i>Add to Cart
                                </button>
                            </div>

                            <div className="bg-custom-cream p-4 rounded-lg">
                                <div className="flex items-center mb-3">
                                    <i className="fa-solid fa-truck text-brand-green text-xl mr-3"></i>
                                    <div>
                                        <p className="font-semibold text-gray-800">Free Shipping</p>
                                        <p className="text-sm text-gray-600">Για παραγγελίες ανω των €80</p>
                                    </div>
                                </div>
                                <div className="flex items-center mb-3">
                                    <i className="fa-solid fa-rotate-left text-brand-green text-xl mr-3"></i>
                                    <div>
                                        <p className="font-semibold text-gray-800">30-Day Returns</p>
                                        <p className="text-sm text-gray-600">Βασει πολιτικής επιστροφών</p>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <i className="fa-solid fa-shield-halved text-brand-green text-xl mr-3"></i>
                                    <div>
                                        <p className="font-semibold text-gray-800">Secure Payment</p>
                                        <p className="text-sm text-gray-600">100% secure checkout</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="product-tabs" className="py-12 bg-cream">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="border-b mb-8">
                        <div className="flex space-x-8">
                            <button
                                className="tab-button active pb-4 px-2 font-semibold text-brand-green border-b-2 border-custom-green"
                                >Description
                            </button>
                           {/* <button
                                className="tab-button pb-4 px-2 font-semibold text-gray-600 hover:text-custom-green"
                                onClick="showTab('specifications')">Specifications
                            </button>
                            <button
                                className="tab-button pb-4 px-2 font-semibold text-gray-600 hover:text-custom-green"
                                onClick="showTab('reviews')">Reviews (48)
                            </button>*/}
                        </div>
                    </div>

                    <div id="description" className="tab-content">
                        <div className="prose max-w-none">
                            <h3 className="text-2xl font-serif font-bold text-brand-green mb-4">Product
                                Description</h3>
                            <p className="text-gray-700 leading-relaxed mb-4">{poductDetails?.details}</p>

                        </div>
                    </div>

                    {/*<div id="specifications" className="tab-content hidden">
                        <h3 className="text-2xl font-serif font-bold text-brand-green mb-6">Technical
                            Specifications</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <table className="w-full">
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Material</td>
                                        <td className="py-3 text-gray-600">Natural Wicker</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Dimensions (Small)</td>
                                        <td className="py-3 text-gray-600">30cm x 25cm</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Weight</td>
                                        <td className="py-3 text-gray-600">0.8 kg</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Color</td>
                                        <td className="py-3 text-gray-600">Natural</td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <table className="w-full">
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Handles</td>
                                        <td className="py-3 text-gray-600">Yes, Reinforced</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Care Instructions</td>
                                        <td className="py-3 text-gray-600">Wipe with damp cloth</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Origin</td>
                                        <td className="py-3 text-gray-600">Greece</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="py-3 font-semibold text-gray-700">Warranty</td>
                                        <td className="py-3 text-gray-600">1 Year</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div id="reviews" className="tab-content hidden">
                        <div className="flex items-start justify-between mb-8">
                            <div>
                                <h3 className="text-2xl font-serif font-bold text-brand-green mb-2">Customer
                                    Reviews</h3>
                                <div className="flex items-center">
                                    <div className="flex text-yellow-400 text-xl mr-3">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star-half-stroke"></i>
                                    </div>
                                    <span className="text-gray-600">4.5 out of 5 (48 reviews)</span>
                                </div>
                            </div>
                            <button
                                className="bg-custom-green text-white px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-colors">Write
                                a Review
                            </button>
                        </div>

                        <div className="space-y-6">
                            <div className="border-b pb-6">
                                <div className="flex items-start justify-between mb-3">
                                    <div>
                                        <div className="flex items-center mb-2">
                                            <img
                                                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                                                className="w-10 h-10 rounded-full mr-3" alt="reviewer"/>
                                            <div>
                                                <p className="font-semibold text-gray-800">Maria Papadopoulos</p>
                                                <div className="flex text-yellow-400 text-sm">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-sm text-gray-500">2 weeks ago</span>
                                </div>
                                <p className="text-gray-700 leading-relaxed">Absolutely beautiful basket! The
                                    craftsmanship is exceptional and it looks even better in person. Perfect size
                                    for my living room and very sturdy. Highly recommend!</p>
                            </div>

                            <div className="border-b pb-6">
                                <div className="flex items-start justify-between mb-3">
                                    <div>
                                        <div className="flex items-center mb-2">
                                            <img
                                                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                                                className="w-10 h-10 rounded-full mr-3" alt="reviewer"/>
                                            <div>
                                                <p className="font-semibold text-gray-800">Dimitris Kostas</p>
                                                <div className="flex text-yellow-400 text-sm">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-regular fa-star"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-sm text-gray-500">1 month ago</span>
                                </div>
                                <p className="text-gray-700 leading-relaxed">Great quality basket. Very well made
                                    and the natural material looks fantastic. Using it for storage in my bedroom.
                                    Only minor issue is it's slightly smaller than expected, but still very happy
                                    with the purchase.</p>
                            </div>

                            <div className="border-b pb-6">
                                <div className="flex items-start justify-between mb-3">
                                    <div>
                                        <div className="flex items-center mb-2">
                                            <img
                                                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
                                                className="w-10 h-10 rounded-full mr-3" alt="reviewer"/>
                                            <div>
                                                <p className="font-semibold text-gray-800">Elena Georgiou</p>
                                                <div className="flex text-yellow-400 text-sm">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-sm text-gray-500">1 month ago</span>
                                </div>
                                <p className="text-gray-700 leading-relaxed">Love this basket! The quality is
                                    outstanding and you can tell it's handmade with care. Fast shipping too. Will
                                    definitely order more from Rotheras!</p>
                            </div>
                        </div>
                    </div>*/}
                </div>
            </section>

            {/*<ProductRelated {...{catid:poductDetails?.categoryRelId,
            id:productId}} />*/}
        </div>
    );

}

export default ProductPage;